<div class="table">
  <div class="table__options" [ngClass]="{'table__options-space': isDownloading, 'table__options-end': !isDownloading}">
    <span class="table__options-title" *ngIf="isDownloading">{{ 'GLOBAL.DOWNLOADING' | translate}}</span>
    <div class="table__options-buttons">
      <div class="trace-viewer__options-inline">
        <bzg-button-icon class="trace-viewer__option" [bzgTooltipPosition]="'above'" *ngIf="selectedTraces.length > 0"
          [bzgTooltip]="'TRACE.DOWNLOAD' | translate" icon="icon-download" [disabled]="isDownloading || isDeleting"
          (click)="downloadFile()"></bzg-button-icon>
        <bzg-button-icon class="bmc-trace__option" [bzgTooltipPosition]="'above'" *ngIf="selectedTraces.length > 0"
          [bzgTooltip]="'TRACE.DELETE' | translate" icon="icon-delete" [disabled]="isDownloading || isDeleting"
          (click)="showConfirmDialog()"></bzg-button-icon>
      </div>
    </div>
  </div>

  <div [ngClass]="setClass()">
    <bzg-table style="width: 100%" [showSelectionColumn]="true" *ngIf="traces && traces.length" [(model)]="traces"
      [showPaginator]="true" (clickItem)="viewdetail($event.item)" [cellSpacingMode]="'compact'"
      (selectItems)="setSelectedTraces($event)" pageSize="10" [allowOrderColumn]="true"
      [orderDirection]="orderDirection" [fixedHeader]="true" [orderColumn]="orderColumnField" [responsive]="true"
      [showSingleLineCell]="true" [showSingleLineHeader]="true">

      <ng-template bzgTableColumn width="40%" id="DisplayName" [allowOrder]="true"
        title="{{'TRACE.RESULT_FILENAME' | translate}}" let-dataItem="dataItem">
        <p title="{{dataItem.DisplayName}}" class="table__labels">{{dataItem.DisplayName}}</p>
      </ng-template>

      <ng-template bzgTableColumn width="20%" id="InstanceName" [allowOrder]="true"
        title="{{'TRACE.INSTANCE_NAME' | translate}}" let-dataItem="dataItem">
        <p title="{{dataItem.InstanceName}}" class="table__labels">{{dataItem.InstanceName}}</p>
      </ng-template>

      <ng-template bzgTableColumn width="20%" id="CreationDate" [allowOrder]="true"
        title="{{'TRACE.CREATION_DATE' | translate}}" let-dataItem="dataItem">
        <p title="{{ dataItem.CreationDate | showDateFormat:6 }}" class="table__labels">{{ dataItem.CreationDate |
          showDateFormat:6}}</p>
      </ng-template>

      <ng-template bzgTableColumn width="20%" id="ModifiedDate" [allowOrder]="true"
        title="{{'TRACE.RESULT_DATE' | translate}}" let-dataItem="dataItem">
        <p title="{{ dataItem.ModifiedDate | showDateFormat:6 }}" class="table__labels">{{ dataItem.ModifiedDate |
          showDateFormat:6}}</p>
      </ng-template>
    </bzg-table>
  </div>
</div>